module.exports = __webpack_public_path__ + "static/media/manufacturing-microone-01 5.218e5e7b.png";